import { Link as c } from "../../node_modules/@tiptap/extension-link/dist/index.mjs";
import { convertStyleObjectToCss as i } from "../../utils/style-helpers.mjs";
import { mergeAttributes as s } from "../../node_modules/@tiptap/core/dist/index.mjs";
const t = (e) => c.extend({
  addAttributes() {
    var r;
    return {
      ...(r = this.parent) == null ? void 0 : r.call(this),
      color: {
        default: (e == null ? void 0 : e.color) ?? "rgb(17 85 204)"
      }
    };
  },
  renderHTML({ HTMLAttributes: r, mark: o }) {
    const n = {
      color: o.attrs.color,
      textDecorationLine: "underline"
    };
    return [
      "a",
      s(r, {
        style: i(n)
      }),
      0
    ];
  }
}), f = (e) => t(e).configure({
  openOnClick: !1
}), k = (e) => t(e).configure({
  HTMLAttributes: {
    rel: "noopener noreferrer"
  }
});
export {
  f as createLinkExtension,
  k as createSimpleLinkExtension
};
